import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';

const editorialWeeks = [
  {
    week: 'Semana 1',
    articles: [
      'Guía de salud sexual: Todo lo que necesitas saber sobre la prevención de ETS.',
      'Mitos y verdades sobre el uso correcto de los métodos de barrera.',
    ],
  },
  {
    week: 'Semana 2',
    articles: [
      'Relaciones de pareja y comunicación: Cómo hablar de protección sin matar el momento.',
      '¿Cómo influye la salud emocional en el bienestar íntimo actual?',
    ],
  },
  {
    week: 'Semana 3',
    articles: [
      'Educación para la vida: La importancia de planificar el futuro en la juventud.',
      'Tendencias en bienestar: Rompiendo tabúes sobre el placer y el autocuidado.',
    ],
  },
  {
    week: 'Semana 4',
    articles: [
      'Preguntas frecuentes al especialista: Lo que siempre quisiste saber sobre salud reproductiva.',
      'Cronología de la prevención: Cómo ha evolucionado la responsabilidad social en el mercado venezolano.',
    ],
  },
];

const ContenidoParaMarcas = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          3. Estrategia editorial
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          TNO Digest — calendario mensual
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" align="center" sx={{ maxWidth: 680, mx: 'auto' }}>
          El portal tnonetwork.com como centro de respuestas para búsquedas orgánicas en Google sobre salud y
          bienestar sexual. Ritmo de <strong>2 artículos semanales</strong> (8 al mes) en todos los planes.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {editorialWeeks.map((item, i) => (
          <Grid item xs={12} sm={6} key={i} data-aos="fade-up">
            <Box
              component={Card}
              height="100%"
              variant="outlined"
              sx={{
                transition: 'all .2s ease-in-out',
                '&:hover': { boxShadow: 4, borderColor: theme.palette.primary.main },
              }}
            >
              <CardContent>
                <Box
                  component={Avatar}
                  variant="rounded"
                  sx={{
                    width: 48,
                    height: 48,
                    mb: 2,
                    bgcolor: `${theme.palette.primary.light}33`,
                    color: theme.palette.primary.dark,
                    fontWeight: 700,
                  }}
                >
                  {i + 1}
                </Box>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.week}
                </Typography>
                {item.articles.map((article, idx) => (
                  <Typography key={idx} variant="body2" color="textSecondary" sx={{ mb: idx === 0 ? 1 : 0 }}>
                    · {article}
                  </Typography>
                ))}
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ContenidoParaMarcas;
